// @flow
import React from 'react';
import cx from 'classnames';
import { H3 } from '../Typography';
import styles from './styles.module.scss';
import i18n from 'i18next';

type Props = {
  className: string,
}

const Logo = ({ className }: Props) => {
  const languageLink = () => {
    const isPlo5 = sessionStorage.getItem('isPlo5') === 'true';
    if (i18n.language === 'en') return `https://omahapro.com/en?isPlo5=${isPlo5}`;
    return `https://omahapro.com/ru?isPlo5=${isPlo5}`;
  };

  return (
    <div className={cx(className, styles.link)}>
      <a href={languageLink()} target="_self" className={styles.a}>
        <div className={styles.logoContainer}>
          <H3 className={styles.logoText} color="light">
            OMAHA
          </H3>
          <H3 className={styles.logoText} style={{ color: '#FF1744' }}>PRO</H3>
        </div>
      </a>
    </div>
  );
};

export default Logo;
